import type { DeploymentState, OmnimizerDeployment } from "./types";

export function deploymentState(
  d: Pick<OmnimizerDeployment, "status" | "current_step">,
): DeploymentState {
  if (d.status === "FAILED") return "failed";
  // vLLM sleep mode: worker alive, weights in host RAM, GPU memory released.
  if (d.status === "PAUSED" && d.current_step === "ASLEEP") return "sleeping";
  if (d.status === "PAUSED" || d.current_step === "PAUSED") return "paused";
  if (d.status === "SUCCESS" && d.current_step === "COMPLETED") return "ready";
  return "inProgress";
}

// GPUs held by a deployment: per-worker GPUs times Dynamo worker replicas.
export function allocatedGpus(d: OmnimizerDeployment) {
  const state = deploymentState(d);
  if (d.is_deleted || !d.is_active || (state !== "ready" && state !== "inProgress")) return 0;
  const perWorker = Number(d.resources?.gpu_count ?? 0) || 0;
  const replicas = d.args?.dynamo?.replicas || d.max_replicas || 1;
  const stages = d.args?.runtime === "dynamo-vllm" && d.args.dynamo?.mode === "disaggregated" ? 2 : 1;
  return perWorker * replicas * stages;
}

export const metricValue = (value: number | null | undefined, digits = 1) =>
  value == null || !Number.isFinite(value)
    ? "—"
    : value.toLocaleString(undefined, { maximumFractionDigits: digits });

// The API stores the full route, e.g. ".../llm/<id>/v1/chat/completions".
export function openAIBaseUrl(endpointUrl: string) {
  return endpointUrl
    .replace(/\/+$/, "")
    .replace(/\/(chat\/completions|completions|embeddings)$/, "")
    .replace(/\/v1$/, "")
    .concat("/v1");
}
